import { animate, timeline as timeline2, stagger } from "vendor";
export class ShopRegionPicker extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.inputCountry = this.querySelector("[data-input-country]");
    this.inputLanguage = this.querySelector("[data-input-language]");

    this.isDesignMode =
      document
        .querySelector("[data-design-mode]")
        ?.getAttribute("data-design-mode") === "true";

    this.isManuallyConfirmedAlready =
      localStorage.getItem("region-picker-manually-confirmed") === "true";

    this.regionPickerBar = document.querySelector("[data-region-picker-bar]");
    this.regionPickerBarCloseButton = document.querySelector(
      "[data-region-picker-close]"
    );
    this.regionPickerBarConfirmButton = document.querySelector(
      "[data-region-picker-confirm]"
    );

    this.selectedFlagCountry = document.querySelector("[data-flag-country]");
    this.selectedTextCountry = document.querySelector("[data-text-country]");
    this.selectedTextLanguage = document.querySelector("[data-text-language]");

    this.countryButtons = document.querySelectorAll("[data-country-button]");
    this.languageButtons = document.querySelectorAll("[data-language-button]");

    this.countryPopover = document.querySelector("[data-country-popover]");
    this.languagePopover = document.querySelector("[data-language-popover]");

    this.countryPopoverButton = document.querySelector(
      "[data-country-popover-button]"
    );
    this.languagePopoverButton = document.querySelector(
      "[data-language-popover-button]"
    );

    this.languageLists = document.querySelectorAll("[data-language-list]");
  }

  setButtonLoading(button) {
    button.setAttribute("aria-busy", "true");
    const animationElement = document.createRange().createContextualFragment(`
    <span class="button__loader">
      <span></span>
      <span></span>
      <span></span>
    </span>
  `).firstElementChild;

    const contentElement = button.querySelector("[data-content]");

    button.insertAdjacentElement("beforeend", animationElement);

    timeline2([
      [
        contentElement,
        { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 },
        { duration: 0.15 },
      ],
      [
        animationElement,
        { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 },
        { duration: 0.15 },
      ],
    ]);

    animate(
      animationElement.children,
      { opacity: [1, 0.1] },
      {
        duration: 0.35,
        delay: stagger(0.35 / 3),
        direction: "alternate",
        repeat: Infinity,
      }
    );
  }

  async connectedCallback() {
    if (this.isManuallyConfirmedAlready || this.isDesignMode) {
      return;
    }

    this.regionPickerBarCloseButton.addEventListener("click", () => {
      this.regionPickerBar.dataset.regionPickerBar = "closed";
    });

    this.regionPickerBarConfirmButton.addEventListener("click", () => {
      localStorage.setItem("region-picker-manually-confirmed", "true");
      if (
        this.regionPickerBarConfirmButton.getAttribute("aria-busy") !== "true"
      ) {
        this.setButtonLoading(this.regionPickerBarConfirmButton);
        this.countryPopoverButton.setAttribute("disabled", "");
        this.languagePopoverButton.setAttribute("disabled", "");
        this.form.submit();
      }
    });

    this.countryButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const countryCode = button.getAttribute("value");
        this.inputCountry.value = countryCode;
        this.selectedFlagCountry.classList.forEach((className) => {
          if (className.includes("country-flags--")) {
            this.selectedFlagCountry.classList.remove(className);
          }
        });
        this.selectedFlagCountry.classList.add(`country-flags--${countryCode}`);
        this.selectedTextCountry.textContent =
          button.dataset.textCountryContent;
        this.countryPopover.removeAttribute("open");
        this.countryPopover.setAttribute("inert", "");
        this.languageLists.forEach((list) => {
          if (list.dataset.languageList === countryCode) {
            list.style.display = "block";
            const targetLanguageButtons = list.querySelectorAll(
              "[data-language-button]"
            );
            const selectedLanguageIsInList = Array.from(
              targetLanguageButtons
            ).some(
              (button) =>
                button.getAttribute("value") === this.inputLanguage.value
            );
            if (!selectedLanguageIsInList) {
              this.inputLanguage.value =
                targetLanguageButtons[0].getAttribute("value");
              this.selectedTextLanguage.textContent =
                targetLanguageButtons[0].dataset.textLanguageContent;
            }
          } else {
            list.style.display = "none";
          }
        });
      });
    });

    this.languageButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const languageCode = button.getAttribute("value");
        this.inputLanguage.value = languageCode;
        this.selectedTextLanguage.textContent =
          button.dataset.textLanguageContent;
        this.languagePopover.removeAttribute("open");
        this.languagePopover.setAttribute("inert", "");
      });
    });

    const currentCountry = window?.Shopify.country?.toLowerCase() ?? "";
    
    try {
      const ipInfoResult = await fetch("https://ipinfo.io/json").then((res) =>
        res.json()
      );
      const country = ipInfoResult.country.toLowerCase();
  
      if (country !== currentCountry) {
        this.regionPickerBar.dataset.regionPickerBar = "country";
      }
    } catch (error) {
      console.error("shop-region-picker: failed to fetch ipinfo", error);
    }
  }
}

customElements.define("shop-region-picker", ShopRegionPicker);
